import React from 'react';

import injectSheet from 'react-jss';
import styles from 'material/controls/control/control_styles';

const Control = (props)=>{

    const handleControlSelect = ()=>{
        props.handleSelect(props.value)
    };

    return(
        <div className={`control ${props.classes.control} selected-${props.selected === props.value}`} onClick={handleControlSelect}>
            <span>{props.text}</span>
        </div>
    )
};

export default injectSheet(styles)(Control);